export default __webpack_public_path__ + "static/media/stepsBg.a7d1d36b.png";